import { ReactNode } from "react";

import { formatDoraDuration } from "../helpers";
import DoraAverage from "./Average";

type DoraTimeAverageProps = {
  averageSeconds: number;
  isLoading: boolean;
  badge?: ReactNode;
};

const DoraTimeAverage = ({ averageSeconds, isLoading, badge }: DoraTimeAverageProps) => {
  return (
    <DoraAverage
      formattedValue={formatDoraDuration(averageSeconds)}
      isLoading={isLoading}
      badge={badge}
    />
  );
};

export default DoraTimeAverage;
